const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.ACITVITY_LOGS)

export const apiLogs = {
	fetchEmployeeLogs: async (id: string, page: number = 1, perPage: number = 20) => {
		const { data, meta } = await apiCommon<ILog[]>(`${groupPrefix}/${id}`, {
			method: 'GET',
			query: { page, perPage },
		})
		return { data: data.map(d => logFromJSON(d)), meta }
	},
}
